import { Box, Flex } from "@chakra-ui/react";
import LaunchdeckButton from './LaunchdeckButton';
import { redirectToNewPage } from '../../../helpers/global-helpers';
import SleepingMascotImage from "./SleepingMascotImage";


export default function PageNotFoundContent() {

	return (
		<Flex direction="column" align="center" bg='white' p='1em' my='2em' rounded='0.8em'>
			<Box fontSize='1.2em' fontWeight='600'>Page not found</Box>
			<Box mt='0.2em' fontSize='0.875em' textAlign={'center'}>But you've found Gnocco, our Chief Doggo Officer, napping here instead!</Box>
			
			<SleepingMascotImage />
			<LaunchdeckButton bg='brand.500' color='white' px='3em' fontSize='0.875em' onClick={() => redirectToNewPage('/home')} label='Ssshh...quietly head back' />
		</Flex>
	)
}

